/* eslint-disable */
export const testData = {
    resultDetail: {
        reportArea1: {
            title: '사고 유형별 강약점',
            strong: '사실적독해',
            weak: '비판적독해',
        },
        reportArea2: {
            title: '질문 유형별 강약점',
            strong: '<보기>가 있는 문항',
            weak: '부정형 질문',
        },
        result: "지문 읽기 활동에서 <b>(4. '윤리의 이해' 지문 읽기 시간은 권장 읽기 시간을 초과하였습니다. 지문을 집중하면서 읽으면서 시간을 단축시키는 연습이 필요합니다. 지문을 여러 번 읽으며 처음 지문 읽을 때 걸린 시간과 다회독 때 읽은 시간을 비교해 보면서 지문 읽기 시간을 줄이는 훈련을 해 보세요.)</b><br/>지문 이해 활동을 살펴보면, <b>(5. 핵심 소재를 파악하는 능력은 갖추었으나, 주제를 찾고 핵심 표현을 정리하는 훈련이 필요합니다. 주제를 잘 파악하기 위해서는 중심 내용을 구조화하여 단락별 핵심내용을 찾는 연습을 꾸준히 해 보세요.)</b><br/>본격독해에서 풀이한 문항 유형별 문제 해결력을 살펴보면, <b>(6. 사실적 독해, 비판적독해, <보기>가 없는 문항) 유형의 문제 해결력은 우수하나, (7. 글 부분에 대한 이해, 부정형질문) 유형에 약합니다. 반복해서 틀리는 문제의 유형을 명확히 파악하고, 유사한 형태의 문제를 매일 일정량 훈련하면 문제 해결력을 향상시킬 수 있습니다.</b>",
    },
    totalAccuracyRate: 13,
    totalLearningResult: {
        coreResult: 50,
        earnestResult: 20,
        vocabularyResult: 70,
    },
    passageList: [
        {
            passageName: '자아 개념의 형성',
            topic: null,
            topicDetail: null,
            kreadScore: '1301',
            accuracyRate: 80,
            coreResult: {
                readingResult: {
                    solveTime: '2분',
                    passageReadTimeMs: 120000,
                },
                understandingResult: [
                    { content: '핵심 소재 및 내용 파악', correctFlag: 'Y' },
                    {
                        content: '중심 내용 파악 및 구조화',
                        correctFlag: 'Y',
                    },
                    { content: '주제 및 핵심 표현 정리', correctFlag: 'N' },
                ],
            },
            earnestElapsedTime: 0,
            earnestResultList: [
                {
                    analysisId: '5077',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '421',
                    learningConceptDetailName: '개괄적 정보 확인',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5078',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '424',
                    learningConceptDetailName: '세부 정보 추론',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5079',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '455',
                    learningConceptDetailName: '반응의 적절성 평가',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5081',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '468',
                    learningConceptDetailName: '문맥적 의미의 유사성 판단',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5077',
                    analysisNm: null,
                    questionClassCode: '02',
                    learningConceptDetailCode: '421',
                    learningConceptDetailName: '개괄적 정보 확인',
                    difficultCode: '04',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5078',
                    analysisNm: null,
                    questionClassCode: '02',
                    learningConceptDetailCode: '422',
                    learningConceptDetailName: '개괄적 내용 추론',
                    difficultCode: '04',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5081',
                    analysisNm: null,
                    questionClassCode: '02',
                    learningConceptDetailCode: '472',
                    learningConceptDetailName: '바꿔 쓰기에 적절한 어휘',
                    difficultCode: '04',
                    correctFlag: 'N',
                },
            ],
            vocabularyElapsedTime: 0,
            vocabularyResultList: [
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
                {
                    content: '어휘의 사전적 의미 파악',
                    correctFlag: 'Y',
                },
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
            ],
        },
        {
            passageName: '독서 치료',
            topic: null,
            topicDetail: null,
            kreadScore: '1312',
            accuracyRate: 70,
            coreResult: {
                readingResult: {
                    solveTime: '2분',
                    passageReadTimeMs: 120000,
                },
                understandingResult: [
                    { content: '핵심 소재 및 내용 파악', correctFlag: 'Y' },
                    {
                        content: '중심 내용 파악 및 구조화',
                        correctFlag: 'Y',
                    },
                    { content: '주제 및 핵심 표현 정리', correctFlag: 'Y' },
                ],
            },
            earnestElapsedTime: 0,
            earnestResultList: [
                {
                    analysisId: '5077',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '424',
                    learningConceptDetailName: '세부 정보 추론',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5078',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '421',
                    learningConceptDetailName: '개괄적 정보 확인',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5079',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '455',
                    learningConceptDetailName: '반응의 적절성 평가',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5081',
                    analysisNm: null,
                    questionClassCode: '01',
                    learningConceptDetailCode: '468',
                    learningConceptDetailName: '문맥적 의미의 유사성 판단',
                    difficultCode: '03',
                    correctFlag: 'N',
                },
                {
                    analysisId: '5081',
                    analysisNm: null,
                    questionClassCode: '02',
                    learningConceptDetailCode: '472',
                    learningConceptDetailName: '바꿔 쓰기에 적절한 어휘',
                    difficultCode: '04',
                    correctFlag: 'N',
                },
            ],
            vocabularyElapsedTime: 0,
            vocabularyResultList: [
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
                {
                    content: '어휘의 사전적 의미 파악',
                    correctFlag: 'Y',
                },
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
                { content: '어휘의 사전적 의미 파악', correctFlag: 'Y' },
            ],
        },
    ],
};
